// import React, { useContext, useState } from 'react'
// import { Link, useLocation, useNavigate } from 'react-router-dom';
// import { userProvider } from '../../../contexts/UserContext';
// import { customerProvider } from '../../../contexts/CustomerContext';
// import { storeInformation } from '../../../contexts/StoreInformationContext';
// import { useTranslation } from 'react-i18next';
// import i18next from 'i18next';
// import { useForm } from 'react-hook-form';
// import axios from 'axios';
// import { toast } from 'react-toastify';
// import { domainProvider } from '../../../contexts/DomainContext';
// import PhoneInput from 'react-phone-input-2';

// function RegisterCompinent() {


//     const { t } = useTranslation();
//     let selectLanguage = i18next.language;
//     const { storeDetails } = useContext(storeInformation);
//     const storeName = storeDetails?.data?.storeDetails?.store_name
//         ? storeDetails?.data?.storeDetails?.store_name
//         : window.location.href.split("/")[3];
//     const { state } = useLocation();
//     const { setIsCustomer, isCustomer } = useContext(customerProvider);
//     const { refetchUser } = useContext(userProvider);
//     const navigate = useNavigate();
//     const [errorTxtN, seterrorTxtN] = useState();
//     const [value, setValue] = useState();
//     const [loading, setLoading] = useState(false);


//     // custom domain
//     const { customdomain } = useContext(domainProvider);



//     const [hide, setHide] = useState(true);
//     const [passwordR, setPasswordR] = useState("password");

//     const EyeRegister = () => {
//         if (passwordR === "password") {
//             setPasswordR("text");
//             setHide(false);
//         } else {
//             setPasswordR("password");
//             setHide(true);
//         }
//     };


//     const {
//         handleSubmit: handleSubmit2,
//         formState: { errors: errors2 },
//         register: register2,
//     } = useForm();

//     const registerSubmit = async (data) => {
//         const userInfo = new FormData();

//         if (!(value?.phone.length === 12)) {
//             seterrorTxtN(
//                 "Please Enter your valid Number with your Country code. Is't must be 12 character"
//             );
//             return;
//         } else {
//             seterrorTxtN("");
//         }

//         userInfo.append("cust_email", data.cust_email);
//         userInfo.append("cust_fullname", data.cust_fullname);
//         userInfo.append("cust_phone", value?.phone);
//         userInfo.append("is_enabled", 1);
//         userInfo.append("password", data.password);
//         userInfo.append("store_name", storeName);

//         setLoading(true);
//         var res;
//         if (customdomain === "aitech.com.sa") {
//             res = await axios.post(
//                 `${process.env.REACT_APP_APIURL}/vendor/store/customer/register`,
//                 userInfo
//             );
//         } else {
//             res = await axios.post(
//                 `${process.env.REACT_APP_APIURL}/vendor/store/customer/register`,
//                 userInfo,
//                 {
//                     headers: {
//                         domain_name: customdomain,
//                         "Content-type": "application/json",
//                     },
//                 }
//             );
//         }
//         const response = await res.data;
//         if (response) {
//             setLoading(false);
//             if (response.status_code === 200) {
//                 toast.info(response.message);
//                 setIsCustomer(!isCustomer);
//                 refetchUser();
//                 if (customdomain === "aitech.com.sa")
//                     navigate(`/${storeName}/customer/verify-email`);
//                 else navigate(`/customer/verify-email`);
//             } else {
//                 toast.error(response.message);
//             }
//         }
//     };
//     return (
//         <form
//             className="border-dashed border-2 p-8 flex flex-col justify-center items-start"
//             onSubmit={handleSubmit2(registerSubmit)}
//         >
//             <div className="form-control w-full">
//                 <label className="label">
//                     <span className="label-text">
//                         {t("Full_Name")}
//                         <span className="text-red-600">*</span>
//                     </span>
//                 </label>
//                 <input
//                     {...register2("cust_fullname", { required: true })}
//                     type="text"
//                     placeholder={t("Full_Name")}
//                     className="input input-bordered focus:outline-none focus:border-gray-300 rounded-none w-full h-[40px]"
//                 />
//                 <label className="label">
//                     {errors2.cust_fullname?.type === "required" && (
//                         <span className="label-text-alt text-red-500 font-Roboto">
//                             {t("u_is_req")}
//                         </span>
//                     )}
//                 </label>
//             </div>

//             <div className="form-control w-full">
//                 <label className="label">
//                     <span className="label-text">
//                         {t("e_address")} <span className="text-red-600">*</span>
//                     </span>
//                 </label>
//                 <input
//                     {...register2("cust_email", { required: true })}
//                     type="email"
//                     placeholder={t("e_address")}
//                     className="input input-bordered focus:outline-none focus:border-gray-300 rounded-none w-full h-[40px]"
//                 />
//                 <label className="label">
//                     {errors2.cust_email?.type === "required" && (
//                         <span className="label-text-alt text-red-500 font-Roboto">
//                             {t("e_address_r")}
//                         </span>
//                     )}
//                 </label>
//             </div>

//             <div className="form-control w-full">
//                 <label className="label">
//                     <span className="label-text">
//                         {t("create_mobile")} <span className="text-red-600">*</span>
//                     </span>
//                 </label>
//                 <PhoneInput
//                     country={"sa"}
//                     onlyCountries={["sa"]}
//                     inputProps={{
//                         required: true,
//                     }}
//                     value={value?.phone}
//                     onChange={(phone) => setValue({ phone })}
//                     isValid={(value, country) => {
//                         if (value.match(/12345/)) {
//                             return "Invalid value: " + value + ", " + country.name;
//                         } else if (value.match(/1234/)) {
//                             return false;
//                         } else {
//                             return true;
//                         }
//                     }}
//                     countryCodeEditable={false}
//                 />
//                 {errorTxtN && (
//                     <span className="label-text-alt text-red-500 font-Roboto">
//                         {errorTxtN}
//                     </span>
//                 )}
//                 <label className="label">
//                     {errors2.contact_no?.type === "required" && (
//                         <span className="label-text-alt text-red-500 font-Roboto">
//                             {t("create_mobile_r")}
//                         </span>
//                     )}
//                 </label>
//             </div>

//             <div className="form-control w-full relative">
//                 <label className="label">
//                     <span className="label-text">
//                         {t("l_p")} <span className="text-red-600">*</span>
//                     </span>
//                 </label>
//                 <input
//                     {...register2("password", { required: true })}
//                     type={passwordR}
//                     placeholder={t("l_p")}
//                     className="input input-bordered focus:outline-none focus:border-gray-300 rounded-none w-full h-[40px]"
//                 />
//                 <i
//                     onClick={EyeRegister}
//                     className={`fa ${hide ? "fa-eye-slash" : "fa-eye"
//                         } cursor-pointer absolute ${selectLanguage === "ar" ? "left-2" : "right-2"
//                         } top-12`}
//                 ></i>
//                 <label className="label">
//                     {errors2.password?.type === "required" && (
//                         <span className="label-text-alt text-red-500 font-Roboto">
//                             {t("l_p_r")}
//                         </span>
//                     )}
//                 </label>
//             </div>

//             <button className="px-5 py-2 bg-blue-600 text-white rounded-full my-3">
//                 {t("regi_btn")}
//             </button>
//             <Link to={"/vendor/register"}>{t("b_vendor")}</Link>
//         </form>
//     )
// }

// export default RegisterCompinent







import React, { useContext, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { userProvider } from '../../../contexts/UserContext';
import { customerProvider } from '../../../contexts/CustomerContext';
import { storeInformation } from '../../../contexts/StoreInformationContext';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import axios from 'axios';
import { toast } from 'react-toastify';
import { domainProvider } from '../../../contexts/DomainContext';
import PhoneInput from 'react-phone-input-2';
import { Form, Input, Button } from 'antd';
import 'react-phone-input-2/lib/style.css';

function RegisterComponent() {
    const { t } = useTranslation();
    let selectLanguage = i18next.language;

    const { storeDetails } = useContext(storeInformation);
    const { setIsCustomer, isCustomer } = useContext(customerProvider);
    const { refetchUser } = useContext(userProvider);
    const { customdomain } = useContext(domainProvider);

    const storeName = storeDetails?.data?.storeDetails?.store_name
        ? storeDetails?.data?.storeDetails?.store_name
        : window.location.href.split("/")[3];

    const { state } = useLocation();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [errorTxtN, setErrorTxtN] = useState();
    const [phone, setPhone] = useState();
    const [showPassword, setShowPassword] = useState(false);

    const onFinish = async (values) => {
        if (!phone || phone.length !== 12) {
            setErrorTxtN(t("Please Enter your valid Number with your Country code. It must be 12 characters."));
            return;
        } else {
            setErrorTxtN("");
        }

        const formData = new FormData();
        formData.append("cust_email", values.cust_email);
        formData.append("cust_fullname", values.cust_fullname);
        formData.append("cust_phone", phone);
        formData.append("is_enabled", 1);
        formData.append("password", values.password);
        formData.append("store_name", storeName);

        setLoading(true);
        let res;
        try {
            if (customdomain === "aitech.com.sa") {
                res = await axios.post(
                    `${process.env.REACT_APP_APIURL}/vendor/store/customer/register`,
                    formData
                );
            } else {
                res = await axios.post(
                    `${process.env.REACT_APP_APIURL}/vendor/store/customer/register`,
                    formData,
                    {
                        headers: {
                            domain_name: customdomain,
                            "Content-type": "application/json",
                        },
                    }
                );
            }
            const response = res.data;
            if (response.status_code === 200) {
                toast.success(response.message);
                setIsCustomer(!isCustomer);
                refetchUser();
                navigate(
                    customdomain === "aitech.com.sa"
                        ? `/${storeName}/customer/verify-email`
                        : `/customer/verify-email`
                );
            } else {
                toast.error(response.message);
            }
        } catch (err) {
            toast.error(t("Something went wrong"));
        } finally {
            setLoading(false);
        }
    };

    return (
        <Form
            layout="vertical"
            onFinish={onFinish}
            className="border-dashed border-2 p-8 flex flex-col justify-center items-start w-full"
        >
            <Form.Item
                name="cust_fullname"
                label={
                    <span>
                        {t("Full_Name")} <span className="text-red-600">*</span>
                    </span>
                }
                rules={[{ required: true, message: t("u_is_req") }]}
                className="w-full"
            >
                <Input className="h-[40px]" />
            </Form.Item>

            <Form.Item
                name="cust_email"
                label={
                    <span>
                        {t("e_address")} <span className="text-red-600">*</span>
                    </span>
                }
                rules={[{ required: true, message: t("e_address_r") }]}
                className="w-full"
            >
                <Input type="email" className="h-[40px]" />
            </Form.Item>

            <div className="w-full mb-4">
                <label className="label">
                    {t("create_mobile")} <span className="text-red-600">*</span>
                </label>
                <PhoneInput
                    country={"sa"}
                    onlyCountries={["sa"]}
                    value={phone}
                    onChange={(val) => setPhone(val)}
                    inputClass="!w-full !h-[40px]"
                    countryCodeEditable={false}
                />
                {errorTxtN && (
                    <span className="text-red-500 text-sm">{errorTxtN}</span>
                )}
            </div>

            <Form.Item
                name="password"
                label={
                    <span>
                        {t("l_p")} <span className="text-red-600">*</span>
                    </span>
                }
                rules={[{ required: true, message: t("l_p_r") }]}
                className="w-full relative"
            >
                <Input.Password
                    type={showPassword ? "text" : "password"}
                    className="h-[40px]"
                    iconRender={(visible) =>
                        visible ? (
                            <i className="fa fa-eye" />
                        ) : (
                            <i className="fa fa-eye-slash" />
                        )
                    }
                />
            </Form.Item>

            <Form.Item className="w-full">
                <button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                      className="w-full btn btn-primary rounded-md text-white mt-4"
                >
                    {t("regi_btn")}
                </button>
            </Form.Item>

            <Link to="/vendor/register" className="text-blue-600 hover:underline">
                {t("b_vendor")}
            </Link>
        </Form>
    );
}

export default RegisterComponent;
